import {
    Component,
    ElementRef,
    Input,
    OnInit,
    QueryList,
    ViewChildren,
  } from '@angular/core';
  import { ModalController, ToastController } from '@ionic/angular';
  import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
  } from '@angular/forms';
  import { DomSanitizer } from '@angular/platform-browser';
  import { BankService } from 'src/app/services/bank/bank.service';
  import { UploadDocument } from 'src/app/core/model/application.model';
  import { CommonService } from 'src/app/services/common/common.service';
  import { ApplicationService } from 'src/app/services/application/application.service';
  import { InvestorPayments } from 'src/app/core/model/payment.model';
  import { Errors, validationType } from '../../core/model/error.model';
  import { ageApprovalbody } from 'src/app/core/model/application.model';
  import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
  @Component({
    selector: 'app-add-transfer',
  templateUrl: './add-transfer.component.html',
  styleUrls: ['./add-transfer.component.scss'],
  })
  export class AddTransferComponent implements OnInit {
    paymentStatus: boolean = false;
    @ViewChildren('fileInput') fileInputs: QueryList<
      ElementRef<HTMLInputElement>
    >;
    @Input() applicationDetails: any;
    fileAttr: string = 'Choose file';
    error = Errors;
    paymentForm = this.fb.group({
      payments: this.fb.array([]),
    });
    holderForm: FormGroup;
    showLoader = false;
    headerText = '';
    messageText = '';
    isError: boolean=false;
    transferDetails: any = [];
    constructor(
      private modalController: ModalController,
      private fb: FormBuilder,
      private bankService: BankService,
      private sanitizer: DomSanitizer,
      private commonService: CommonService,
      private applicationService: ApplicationService,
      private dropdownService: DropdownService,
      private readonly toastController: ToastController
    ) {}
  
    ngOnInit() {

      this.getTransferDetails();
    }
  

    getTransferDetails(){
      var test=this.applicationDetails;
      var folioNo=this.applicationDetails.folioNo;
      console.log("test" , test);

      const body: any = {};
    body.FolioNo = this.applicationDetails.folioNo;
    body.FundId = this.applicationDetails.childFundId;
    body.PanNo = this.applicationDetails.pan;

    console.log("panmodeltransfer", body);
  //  return;

      this.dropdownService.getTransferDetailsByFolio(body).subscribe(
        (res: any) => {
          console.log("transfer details : rahin : ", res.data);
          this.transferDetails = res.data;
          // this.transferIDs = res.data.transferDetails;
          // console.log("this.transferId", this.transferIDs);
          // this.transferIDs = this.transferIDs.filter(x => x.status == 'Approved' && x.buyerUserId == this.distributorDetails[0].UserId);
          // console.log("this.transferId", this.transferIDs);
        },
        (err) => {
          console.log("Error =>", err)
        }
      );
    }

    async presentToast(message: string) {
      const toast = await this.toastController.create({
        message: message,
        duration: 2000,
      });
      toast.present();
    }
  
    dismissModal() {
      this.modalController.dismiss();
    }
  }
  